// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RIaW7{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;border-top:1px solid #e0e8f2;gap:24px;margin-top:3.2rem;padding-top:24px}", ""]);
// Exports
exports.locals = {
	"standardActions": "RIaW7"
};
module.exports = exports;
